import React, { useEffect, useLayoutEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Helmet } from "react-helmet";

import Layout from "../components/common/layout/Index";
import WelcomeComponent from "../components/home/section/WelcomeComponent";
import HomePage from "../components/home/HomePage";
import useTranslationHook from "../components/hooks/useTranslationHook";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import {
    consumedInvitationToken,
    validateInvitationToken,
} from "../redux/action/buyerAction";
import { accountStatus } from "../utils/constants";
import { handleAccountStatus } from "../redux/action/verificationAction";
import { loadUser } from "../redux/action/authAction";

function Home() {
    const isAuthenticated = useSelector((state) => state.auth?.isAuthenticated);
    const user = useSelector((state) => state.auth?.user);
    const { t } = useTranslationHook();
    const { token } = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const handleKycVerification = () => {
        if (user?.is_account_verified === accountStatus.success) {
            dispatch(handleAccountStatus(accountStatus.success));
        } else if (user?.is_account_verified === accountStatus.under_review) {
            dispatch(
                loadUser({
                    site_id: user.site_id,
                })
            ).then((res) => {
                if (res?.error === 0) {
                    dispatch(handleAccountStatus(res.data.is_account_verified));
                }
            });
        } else dispatch(handleAccountStatus(""));
        navigate("/verify");
    };

    useLayoutEffect(() => {
        if (token) {
            dispatch(validateInvitationToken(token, navigate)).then((res) => {
                if (
                    (isAuthenticated &&
                        `${res?.data?.invitee_email}`.toLocaleLowerCase() !==
                            `${user?.email}`.toLocaleLowerCase()) ||
                    res?.error === 1 ||
                    (res?.error === 1 &&
                        res?.msg?.toLocaleLowerCase() ===
                            "This invitation link has expired."?.toLocaleLowerCase())
                ) {
                    // toast.info(t("The currently logged-in account email does not match the email authorized for this private auction"))
                    if (
                        res?.msg?.toLocaleLowerCase() ===
                        "This invitation link has expired."?.toLocaleLowerCase()
                    ) {
                        toast?.info(res?.msg);
                    }
                    navigate("/private-auction-restricted");
                    return;
                }

                if (
                    res?.msg?.toLocaleLowerCase() ===
                        "This invitation has already been accepted."?.toLocaleLowerCase() &&
                    res?.error === 0
                ) {
                    // if (!user?.user_kyc) {
                    //     handleKycVerification();
                    // } else {
                    !isAuthenticated
                        ? res?.data?.next_step === "login"
                            ? navigate(
                                  `/sign-in?redirect=${encodeURIComponent(
                                      `/property/detail/${res?.data?.property_id}`
                                  )}&email=${encodeURIComponent(res?.data?.invitee_email || "")}`
                              )
                            : navigate("/private-auction-restricted")
                        : navigate(
                              `/property/detail/${res?.data?.property_id}`
                          );
                    // }
                    return;
                }

                if (
                    isAuthenticated &&
                    `${res?.data?.invitee_email}`.toLocaleLowerCase() ===
                        `${user?.email}`.toLocaleLowerCase()
                ) {
                    dispatch(consumedInvitationToken(token))
                        .then((response) => {
                            const { status, data } = response || {};

                            if (status === 200 && data?.error === 0) {
                                // if (!user?.user_kyc) {
                                //     handleKycVerification();
                                // } else {
                                navigate(
                                    `/property/detail/${res?.data?.property_id}`
                                );
                                // }
                            }
                        })
                        .catch((err) => {
                            console.error(err);
                        });

                    return;
                }
                if (!res?.data?.has_account) {
                    toast.info(
                        t(
                            "You have been invited to an exclusive private auction. Please sign up to continue."
                        )
                    );
                }
                navigate(
                    res?.data?.has_account
                        ? `/sign-in?redirect=${encodeURIComponent(
                              `/property/detail/${res?.data?.property_id}`
                          )}&email=${encodeURIComponent(res?.data?.invitee_email || "")}`
                        : `/sign-in`
                );
            });
        } else {
            // console.log("No token found");
        }
    }, [token]);

    useLayoutEffect(() => {
        let msg = sessionStorage.getItem("inactiveUser");
        let deleteUserMsg = sessionStorage.getItem("deleteUserMsg");
        let sessionExpired = sessionStorage.getItem("sessionExpired");
        if (sessionExpired) {
            toast.info(
                t("Your session has expired. Please sign in again.")
            );
            sessionStorage.removeItem("sessionExpired");
        }
        if (msg) {
            toast.error(t("You are not active user."));
            sessionStorage.removeItem("inactiveUser");
        }
        if (deleteUserMsg) {
            toast.error(t("Account deleted successfully."));
            sessionStorage.removeItem("deleteUserMsg");
        }
    }, []);

    return (
        <>
            <Helmet>
                <meta
                    name="keywords"
                    content={t(
                        "Bidhome-Adres, CRE, brokers, investment, commercial real estate, sales, auction"
                    )}
                />
                <meta
                    name="description"
                    content={t(
                        "Bidhome-Adres brings buyers, sellers, and brokers together to efficiently market and close commercial real estate deals in online CRE auctions."
                    )}
                />
                <title>{t("Property Auction - Home Page")}</title>
            </Helmet>
            <Layout>
                {isAuthenticated ? <WelcomeComponent /> : <></>}
                <HomePage />
            </Layout>
        </>
    );
}

export default Home;
